<div class="modal-fade-up relative flex flex-row h-full w-full" aria-labelledby="modal-title" role="dialog"
    aria-modal="true">

    <div
        class="absolute inset-0 z-10 overflow-hidden green-noise-bg bg-slate-50/95 dark:bg-[rgba(194,193,195,0.4)] flex items-center justify-center">

        <button type="button" (click)="closeModal()"
            class="absolute top-2 left-2 z-20 rounded-full bg-zinc-200 dark:bg-zinc-600 p-1.5 sm:p-2 text-primary shadow-sm hover:bg-zinc-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-600">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                stroke="currentColor" class="size-5 sm:size-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>

        </button>


        @if (!subscriptionLoadingCtrl()) {
        <div
            class="relative w-[90%] h-[90%] primary-card-container-no-padding flex flex-col overflow-hidden gap-y-2 bg-white/80 dark:bg-transparent rounded-2xl shadow-xl dark:shadow-none border border-slate-200/80 dark:border-transparent">
            <div aria-hidden="true" class="absolute inset-x-0 transform-gpu overflow-hidden blur-3xl sm:-top-80">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%-11rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 rotate-[30deg] bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%-30rem)] sm:w-[72.1875rem]">
                </div>
            </div>

            <!-- Subscription Content -->
            <div class="relative z-10 flex flex-col h-full w-full overflow-hidden">

                <div class="flex-1 flex-col overflow-y-auto scrollbar-transparent">

                    <!-- Header Section -->
                    <div class="text-center pt-8 pb-6 px-4">
                        <h2 class="text-4xl sm:text-5xl font-bold text-zinc-900 dark:text-white mb-3 use-grotesque">
                            <span
                                class="text-transparent bg-clip-text bg-gradient-to-r from-[#ff80b5] to-[#9089fc]">Customise</span>
                            your plan
                        </h2>
                        <p class="text-zinc-600 dark:text-zinc-400 text-sm sm:text-base max-w-xl mx-auto">
                            Add useful bolt-ons to power up your workflow.
                        </p>
                    </div>

                    <!-- Main Content Area -->
                    <div class="flex-1 px-4 sm:px-8 pb-6">
                        <!-- Add One Bolt-On -->
                        @if (subscriptionService.selectedBoltOns() && subscriptionService.selectedBoltOns().size == 1)
                        {
                        <div
                            class="mx-auto mb-8 mt-4 max-w-2xl rounded-2xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900/60 backdrop-blur-sm shadow-sm dark:shadow-none sm:mt-6 lg:mx-0 lg:flex lg:max-w-none">
                            <div class="p-8 sm:p-10 lg:flex-auto">
                                <h3 class="text-3xl font-semibold tracking-tight text-zinc-900 dark:text-white">{{
                                    getBoltOnName(subscriptionService.selectedBoltOns()) }}</h3>
                                <p class="mt-6 text-base leading-7 text-zinc-600 dark:text-zinc-400">{{
                                    choosePlanService.subscriptionPlans[0].description }}</p>
                                <div class="mt-10 flex items-center gap-x-4">
                                    <h4 class="flex-none text-sm font-semibold text-accent">
                                        What's included</h4>
                                    <div class="h-px flex-auto bg-zinc-200 dark:bg-zinc-700"></div>
                                </div>
                                <ul role="list"
                                    class="mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-zinc-600 sm:grid-cols-2 sm:gap-6 dark:text-zinc-300">
                                    @for (feature of getBoltOnFeatures(subscriptionService.selectedBoltOns()); track
                                    feature) {
                                    <li class="flex gap-x-3">
                                        <svg class="h-5 w-5 shrink-0 text-accent" viewBox="0 0 20 20"
                                            fill="currentColor" aria-hidden="true">
                                            <path
                                                d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                clip-rule="evenodd" fill-rule="evenodd" />
                                        </svg>
                                        {{ feature }}
                                    </li>
                                    }
                                </ul>
                            </div>
                            <div class="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                                <div
                                    class="rounded-2xl border border-zinc-200 dark:border-zinc-800 bg-zinc-50 dark:bg-zinc-800/60 py-10 text-center lg:flex lg:flex-col lg:justify-center lg:py-16">
                                    <div class="mx-auto max-w-xs px-8">
                                        <p class="text-base font-semibold text-zinc-600 dark:text-zinc-400">Cost of
                                            Bolt-Ons
                                        </p>
                                        <p class="mt-6 flex items-baseline justify-center gap-x-2">
                                            <span
                                                class="text-5xl font-semibold tracking-tight text-zinc-900 dark:text-white">{{
                                                getBoltOnPrice(subscriptionService.selectedBoltOns()) | currency: 'GBP'
                                                }}</span>
                                            <span
                                                class="text-sm font-semibold tracking-wide text-zinc-600 dark:text-zinc-400">/month</span>
                                        </p>
                                        <button type="button" (click)="addBoltOnToPlan()"
                                            class="mt-10 block w-full rounded-xl bg-primary px-3 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                                            Add to Plan
                                        </button>
                                        <p class="mt-6 text-xs text-zinc-600 dark:text-zinc-400">Invoices and receipts
                                            available for easy company reimbursement</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                        <!-- Add One Bolt-On -->
                        @else if (subscriptionService.selectedBoltOns() &&
                        subscriptionService.selectedBoltOns().size > 1) {


                        <div
                            class="mx-auto mb-8 mt-4 max-w-2xl rounded-2xl border border-zinc-200 dark:border-zinc-800 bg-white dark:bg-zinc-900/60 backdrop-blur-sm shadow-sm dark:shadow-none sm:mt-6 lg:mx-0 lg:flex lg:max-w-none">
                            <div class="p-8 sm:p-10 lg:flex-auto">
                                <h3 class="text-3xl font-semibold tracking-tight text-zinc-900 dark:text-white">{{
                                    subscriptionService.selectedBoltOns().size }} Bolt-Ons Selected</h3>
                                <p class="mt-6 text-base leading-7 text-zinc-600 dark:text-zinc-400">When you're happy
                                    to continue, click the button below to add them to your plan.</p>
                                <div class="mt-10 flex items-center gap-x-4">
                                    <h4 class="flex-none text-sm font-semibold text-accent">
                                        Selected Bolt-Ons</h4>
                                    <div class="h-px flex-auto bg-zinc-200 dark:bg-zinc-700"></div>
                                </div>
                                <ul role="list"
                                    class="mt-8 grid grid-cols-1 gap-4 text-sm leading-6 text-zinc-600 sm:grid-cols-2 sm:gap-6 dark:text-zinc-300">
                                    @for (selectedBoltOn of subscriptionService.selectedBoltOns(); track $index) {
                                    <li
                                        class="flex flex-col gap-y-3 rounded-xl border border-zinc-200 dark:border-zinc-700 bg-zinc-50/70 dark:bg-zinc-900/40 p-4">
                                        <div class="flex items-center gap-x-3">
                                            <svg class="h-5 w-5 shrink-0 text-accent" viewBox="0 0 20 20"
                                                fill="currentColor" aria-hidden="true">
                                                <path
                                                    d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                                    clip-rule="evenodd" fill-rule="evenodd" />
                                            </svg>
                                            <span class="font-semibold text-zinc-900 dark:text-white">
                                                {{ getBoltOnNameFromId(selectedBoltOn) }}
                                            </span>
                                        </div>
                                        <ul
                                            class="mt-1 space-y-1 text-xs text-zinc-600 dark:text-zinc-300 list-disc list-inside">
                                            @for (detail of getBoltOnFeaturesFromId(selectedBoltOn); track detail) {
                                            <li>
                                                {{ detail }}
                                            </li>
                                            }
                                        </ul>
                                    </li>
                                    }
                                </ul>
                            </div>
                            <div class="-mt-2 p-2 lg:mt-0 lg:w-full lg:max-w-md lg:shrink-0">
                                <div
                                    class="rounded-2xl border border-zinc-200 dark:border-zinc-800 bg-zinc-50 dark:bg-zinc-800/60 py-10 text-center lg:flex lg:flex-col lg:justify-center lg:py-16">
                                    <div class="mx-auto max-w-xs px-8">
                                        <p class="text-base font-semibold text-zinc-600 dark:text-zinc-400">Per month
                                        </p>
                                        <p class="mt-6 flex items-baseline justify-center gap-x-2">
                                            <span
                                                class="text-5xl font-semibold tracking-tight text-zinc-900 dark:text-white">{{
                                                totalBoltOnsMonthly() | currency: 'GBP'
                                                }}</span>
                                            <span
                                                class="text-sm font-semibold tracking-wide text-zinc-600 dark:text-zinc-400">/month</span>
                                        </p>
                                        <button type="button" (click)="addBoltOnToPlan()"
                                            class="mt-10 block w-full rounded-xl bg-primary px-3 py-2.5 text-center text-sm font-semibold text-white shadow-sm hover:bg-primary focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary dark:bg-primary dark:hover:bg-primary/90 dark:focus-visible:outline-primary">
                                            Add to Plan
                                        </button>
                                        <p class="mt-6 text-xs text-zinc-600 dark:text-zinc-400">Invoices and receipts
                                            available for easy company reimbursement</p>
                                    </div>
                                </div>
                            </div>
                        </div>



                        } @else {

                        <div
                            class="rounded-md bg-green-50 p-4 dark:bg-green-500/10 dark:outline dark:outline-green-500/15">
                            <div class="flex">
                                <div class="shrink-0">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="size-5 text-green-400 dark:text-green-300">
                                        <circle cx="12" cy="12" r="10" />
                                        <path
                                            d="M11.051 7.616a1 1 0 0 1 1.909.024l.737 1.452a1 1 0 0 0 .737.535l1.634.256a1 1 0 0 1 .588 1.806l-1.172 1.168a1 1 0 0 0-.282.866l.259 1.613a1 1 0 0 1-1.541 1.134l-1.465-.75a1 1 0 0 0-.912 0l-1.465.75a1 1 0 0 1-1.539-1.133l.258-1.613a1 1 0 0 0-.282-.867l-1.156-1.152a1 1 0 0 1 .572-1.822l1.633-.256a1 1 0 0 0 .737-.535z" />
                                    </svg>
                                </div>
                                <div class="ml-3">
                                    <h3 class="text-sm font-medium text-green-800 dark:text-green-100">Add power to your
                                        toolset.</h3>
                                    <div class="mt-2 text-sm text-green-700 dark:text-green-100/80">
                                        <p>Add Bolt-Ons to your plan to enhance your workflow, boost your productivity
                                            and supercharge your results.</p>
                                    </div>
                                </div>
                            </div>
                        </div>


                        }
                    </div>


                    <!-- Bolt-Ons Section -->
                    <div class="mx-auto mb-6 px-4 sm:px-8 pb-6">
                        <h3 class="text-lg font-semibold text-zinc-900 dark:text-white mb-4 flex items-center gap-2">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" class="w-5 h-5 text-accent">
                                <path stroke-linecap="round" stroke-linejoin="round"
                                    d="M3.75 13.5l10.5-11.25L12 10.5h8.25L9.75 21.75 12 13.5H3.75z" />
                            </svg>
                            Bolt-Ons <span
                                class="text-zinc-600 dark:text-zinc-400 text-sm font-normal">(Optional)</span>
                        </h3>

                        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
                            @for (boltOn of choosePlanService.boltOns; track boltOn.stripe_id) {
                            <div (click)="toggleBoltOn(boltOn.stripe_id)" class="relative cursor-pointer">
                                <div class="h-full p-4 bg-white dark:bg-zinc-900/40 backdrop-blur-sm border border-zinc-200 dark:border-zinc-800 rounded-xl transition-all duration-300 hover:border-zinc-300 dark:hover:border-zinc-600 shadow-sm dark:shadow-none"
                                    [class.border-primary]="isBoltOnSelected(boltOn.stripe_id)"
                                    [class]="isBoltOnSelected(boltOn.stripe_id) ? 'bg-primary/10 dark:bg-primary/20' : ''">

                                    <!-- Checkbox -->
                                    <div class="flex items-start justify-between mb-3">
                                        <div
                                            class="w-8 h-8 rounded-lg bg-zinc-100 dark:bg-zinc-800 flex items-center justify-center">
                                            @switch (boltOn.id) {
                                            @case ('ai-moderation') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-6 text-zinc-600 dark:text-white">
                                                <path
                                                    d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
                                            </svg>
                                            }
                                            @case ('creator-screening') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-6 text-zinc-600 dark:text-white">
                                                <path d="M3 7V5a2 2 0 0 1 2-2h2" />
                                                <path d="M17 3h2a2 2 0 0 1 2 2v2" />
                                                <path d="M21 17v2a2 2 0 0 1-2 2h-2" />
                                                <path d="M7 21H5a2 2 0 0 1-2-2v-2" />
                                                <path d="M8 14s1.5 2 4 2 4-2 4-2" />
                                                <path d="M9 9h.01" />
                                                <path d="M15 9h.01" />
                                            </svg>
                                            }
                                            @case ('gifting-seeding') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-6 text-zinc-600 dark:text-white">
                                                <path d="M12 7v14" />
                                                <path d="M20 11v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8" />
                                                <path
                                                    d="M7.5 7a1 1 0 0 1 0-5A4.8 8 0 0 1 12 7a4.8 8 0 0 1 4.5-5 1 1 0 0 1 0 5" />
                                                <rect x="3" y="7" width="18" height="4" rx="1" />
                                            </svg>
                                            }
                                            @case ('affiliates-shopify') {
                                            <svg width="2192" height="2500" viewBox="0 0 256 292"
                                                xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid"
                                                class="size-6">
                                                <path
                                                    d="M223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-1.703-1.703-5.029-1.185-6.32-.805-.19.056-3.388 1.043-8.678 2.68-5.18-14.906-14.322-28.604-30.405-28.604-.444 0-.901.018-1.358.044C129.31 3.407 123.644.779 118.75.779c-37.465 0-55.364 46.835-60.976 70.635-14.558 4.511-24.9 7.718-26.221 8.133-8.126 2.549-8.383 2.805-9.45 10.462C21.3 95.806.038 260.235.038 260.235l165.678 31.042 89.77-19.42S223.973 58.8 223.775 57.34zM156.49 40.848l-14.019 4.339c.005-.988.01-1.96.01-3.023 0-9.264-1.286-16.723-3.349-22.636 8.287 1.04 13.806 10.469 17.358 21.32zm-27.638-19.483c2.304 5.773 3.802 14.058 3.802 25.238 0 .572-.005 1.095-.01 1.624-9.117 2.824-19.024 5.89-28.953 8.966 5.575-21.516 16.025-31.908 25.161-35.828zm-11.131-10.537c1.617 0 3.246.549 4.805 1.622-12.007 5.65-24.877 19.88-30.312 48.297l-22.886 7.088C75.694 46.16 90.81 10.828 117.72 10.828z"
                                                    fill="#95BF46" />
                                                <path
                                                    d="M221.237 54.983c-1.055-.088-23.383-1.743-23.383-1.743s-15.507-15.395-17.209-17.099c-.637-.634-1.496-.959-2.394-1.099l-12.527 256.233 89.762-19.418S223.972 58.8 223.774 57.34c-.201-1.46-1.48-2.268-2.537-2.357"
                                                    fill="#5E8E3E" />
                                                <path
                                                    d="M135.242 104.585l-11.069 32.926s-9.698-5.176-21.586-5.176c-17.428 0-18.305 10.937-18.305 13.693 0 15.038 39.2 20.8 39.2 56.024 0 27.713-17.577 45.558-41.277 45.558-28.44 0-42.984-17.7-42.984-17.7l7.615-25.16s14.95 12.835 27.565 12.835c8.243 0 11.596-6.49 11.596-11.232 0-19.616-32.16-20.491-32.16-52.724 0-27.129 19.472-53.382 58.778-53.382 15.145 0 22.627 4.338 22.627 4.338"
                                                    fill="#FFF" />
                                            </svg>
                                            }
                                            @case ('affiliates-rakuten') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="72.97" height="77.64"
                                                viewBox="0 0 72.97 77.64" class="size-6">
                                                <g id="rakuten-edy-logo" transform="translate(-3.99)">
                                                    <path id="Path_12" data-name="Path 12"
                                                        d="M14.4,77.64,3.99,68.91H76.96ZM26.25,62.36V43h8.38L49.14,62.36H64L46.44,39A21.49,21.49,0,0,0,34,0H14.4V62.36Zm0-50.52H34a9.67,9.67,0,1,1,0,19.33H26.25Z"
                                                        fill="#bf0000" />
                                                </g>
                                            </svg>
                                            }
                                            @case ('social-monitoring') {
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-6 text-zinc-600 dark:text-white">
                                                <path
                                                    d="M16.75 12h3.632a1 1 0 0 1 .894 1.447l-2.034 4.069a1 1 0 0 1-1.708.134l-2.124-2.97" />
                                                <path
                                                    d="M17.106 9.053a1 1 0 0 1 .447 1.341l-3.106 6.211a1 1 0 0 1-1.342.447L3.61 12.3a2.92 2.92 0 0 1-1.3-3.91L3.69 5.6a2.92 2.92 0 0 1 3.92-1.3z" />
                                                <path d="M2 19h3.76a2 2 0 0 0 1.8-1.1L9 15" />
                                                <path d="M2 21v-4" />
                                                <path d="M7 9h.01" />
                                            </svg>
                                            }
                                            }
                                        </div>
                                        <div class="w-5 h-5 rounded border-2 flex items-center justify-center transition-all duration-300 border-zinc-300 dark:border-zinc-600"
                                            [class.border-primary]="isBoltOnSelected(boltOn.stripe_id)"
                                            [class.bg-primary]="isBoltOnSelected(boltOn.stripe_id)">
                                            @if (isBoltOnSelected(boltOn.stripe_id)) {
                                            <svg class="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24"
                                                stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3"
                                                    d="M5 13l4 4L19 7" />
                                            </svg>
                                            }
                                        </div>
                                    </div>

                                    <h4 class="text-sm font-semibold text-zinc-900 dark:text-white mb-1">{{
                                        boltOn.name }}</h4>
                                    <p class="text-xs text-zinc-600 dark:text-zinc-400 mb-2">{{ boltOn.description
                                        }}</p>
                                    <div class="flex items-center justify-between gap-2">
                                        @if (isBoltOnIncluded(boltOn.stripe_id)) {
                                        <div class="text-lg font-bold text-green-600 dark:text-green-400">Included
                                        </div>
                                        } @else {
                                        <div class="text-lg font-bold text-accent">£{{
                                            boltOn.price }}<span class="text-xs text-zinc-500 font-normal">/mo</span>
                                        </div>
                                        }
                                        <button type="button"
                                            (click)="$event.stopPropagation(); toggleBoltOnInfo(boltOn.stripe_id)"
                                            class="shrink-0 rounded-full p-1.5 text-zinc-500 hover:bg-zinc-100 hover:text-zinc-700 dark:text-zinc-400 dark:hover:bg-zinc-800 dark:hover:text-zinc-200 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
                                            [attr.aria-expanded]="isBoltOnInfoExpanded(boltOn.stripe_id)"
                                            aria-label="More info">
                                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                                stroke-width="1.5" stroke="currentColor" class="size-5">
                                                <path stroke-linecap="round" stroke-linejoin="round"
                                                    d="m11.25 11.25.041-.02a.75.75 0 0 1 1.063.852l-.708 2.836a.75.75 0 0 0 1.063.853l.041-.021M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9-3.75h.008v.008H12V8.25Z" />
                                            </svg>
                                        </button>
                                    </div>
                                    @if (isBoltOnInfoExpanded(boltOn.stripe_id)) {
                                    <ul class="mt-3 space-y-1.5 border-t border-zinc-200 dark:border-zinc-700 pt-3">
                                        @for (detail of boltOn.mode_details; track detail) {
                                        <li class="flex items-start gap-2 text-xs text-zinc-600 dark:text-zinc-300">
                                            <svg class="mt-0.5 size-4 shrink-0 text-accent" fill="none"
                                                viewBox="0 0 24 24" stroke="currentColor">
                                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                                    d="M5 13l4 4L19 7" />
                                            </svg>
                                            <span>{{ detail }}</span>
                                        </li>
                                        }
                                    </ul>
                                    }
                                </div>
                            </div>
                            }
                        </div>
                    </div>

                </div>

                <!-- Footer / Order Summary -->
                <div
                    class="shrink-0 flex flex-row items-center justify-between py-2 px-4 border-t border-zinc-200 dark:border-zinc-700 bg-slate-50/50 dark:bg-transparent">
                    <!-- Price Display -->
                    <div class="flex items-center gap-4">
                        <div class="text-center sm:text-left">
                            <div class="text-sm text-zinc-600 dark:text-zinc-400">Total per month</div>
                            <div class="flex items-baseline gap-2">
                                <span class="text-2xl font-bold text-zinc-900 dark:text-white">£{{ totalMonthly()
                                    }}</span>
                                <span class="text-zinc-600 dark:text-zinc-400">/month</span>
                            </div>
                        </div>
                        <div class="hidden sm:block h-10 w-px bg-zinc-300 dark:bg-zinc-700"></div>
                        <div class="hidden sm:block text-sm text-zinc-600 dark:text-zinc-400">
                            <div>Totaly Monthly Cost (Including your plan and bolt-ons)</div>
                            @if (subscriptionService.selectedBoltOns().size > 0) {
                            <div class="text-accent">+ {{
                                subscriptionService.selectedBoltOns().size
                                }} Bolt-on{{ subscriptionService.selectedBoltOns().size > 1 ? 's' : '' }}</div>
                            }
                        </div>
                    </div>

                    <!-- Subscribe Button -->
                    <button (click)="addBoltOnToPlan()" class="w-full sm:w-auto flashy-go-button inline-flex gap-x-2">
                        Accept Changes
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="size-5 shrink-0">
                            <path d="M5 12h14" />
                            <path d="m12 5 7 7-7 7" />
                        </svg>

                    </button>
                    <!-- </div> -->
                </div>

            </div>

            <div aria-hidden="true"
                class="absolute inset-x-0 top-[calc(100%-13rem)] transform-gpu overflow-hidden blur-3xl sm:top-[calc(100%-30rem)]">
                <div style="clip-path: polygon(74.1% 44.1%, 100% 61.6%, 97.5% 26.9%, 85.5% 0.1%, 80.7% 2%, 72.5% 32.5%, 60.2% 62.4%, 52.4% 68.1%, 47.5% 58.3%, 45.2% 34.5%, 27.5% 76.7%, 0.1% 64.9%, 17.9% 100%, 27.6% 76.8%, 76.1% 97.7%, 74.1% 44.1%)"
                    class="relative left-[calc(50%+3rem)] aspect-[1155/678] w-[36.125rem] -translate-x-1/2 bg-gradient-to-tr from-[#ff80b5] to-[#9089fc] opacity-30 sm:left-[calc(50%+36rem)] sm:w-[72.1875rem]">
                </div>
            </div>

        </div>
        } @else {
        <div
            class="relative w-[90%] h-[90%] primary-card-container-no-padding flex flex-col overflow-hidden gap-y-2 bg-white/80 dark:bg-transparent rounded-2xl shadow-xl dark:shadow-none border border-slate-200/80 dark:border-transparent items-center justify-center">
            <!-- <om-vortex class="w-full h-full"> -->
            <div class="w-full h-full">
                <div class="content flex items-center justify-center">
                    <div class="text-center">
                        <svg aria-hidden="true"
                            class="mx-auto w-16 h-16 text-gray-200 animate-spin dark:text-gray-500 fill-primary"
                            viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="currentColor" />
                            <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="currentFill" />
                        </svg>
                        <h3 class="mt-8 text-sm font-semibold text-primary">Loading...</h3>
                        <p class="mt-1 text-sm text-secondary">Assembling your plan.</p>
                    </div>
                </div>
            </div>
            <!-- </om-vortex> -->
        </div>

        }

    </div>
</div>